import React, { useState, useRef } from 'react';
import css from 'styled-jsx/css';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import scrollTo from '../../../lib/js/scrollTo';

import AddNewPaymentMethod from './AddNewPaymentMethod';
import RemovePaymentMethod from './RemovePaymentMethod';
import PaymentCard from './PaymentCard';

const CARD_ITEM_WIDTH = '350px';

const paymentMethodsStyles = css`
  .payment-card-list {
    margin: 0;
    padding: 0;
  }

  .payment-card-item {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;
    flex-direction: column;
    list-style: none;
    box-sizing: border-box;
  }

  .payment-card-item--removed {
    transition: 0.3s opacity ease;
    opacity: 0;
  }

  .card-remove {
    text-align: right;
  }

  @media (min-width: 400px) {
    .payment-card-item {
      width: ${CARD_ITEM_WIDTH};
    }
  }

  @media (min-width: 780px) {
    .payment-card-item {
      margin-left: 0;
    }

    .payment-card-list {
      display: flex;
      flex-wrap: wrap;
    }
  }

  @media (min-width: 1030px) {
    .payment-card-item {
      margin-right: calc((100% - (${CARD_ITEM_WIDTH} * 2)) / 2);
    }
  }
`;

const PaymentMethods = ({ profile, cards: initialCards }) => {
  const paymentMethodKnownRef = useRef(null);
  const [defaultCard, setDefaultCard] = useState(
    initialCards.find(card => card.default)
  );
  const [cards, setCards] = useState(
    initialCards.filter(card => !card.default)
  );
  const addCard = card => {
    setCards([card, ...cards]);
    activateCard(card);
    goToPaymentKnownEl();
  };
  const activateCard = card => {
    setCards([...cards.filter(c => c.id !== card.id), defaultCard]);
    card.default = true;
    card.action = 'newDefault';
    setDefaultCard(card);
    goToPaymentKnownEl();
  };
  const goToPaymentKnownEl = () => {
    if (paymentMethodKnownRef) {
      const top = paymentMethodKnownRef.current.offsetTop;
      scrollTo({ top });
    }
  };
  const removeCard = removedCard => {
    const updatedCards = cards.map(card => {
      if (card.id === removedCard.id) {
        return removedCard;
      }
      return card;
    });
    setCards(updatedCards);
    setTimeout(() => {
      const filteredCards = cards.filter(card => card.id !== removedCard.id);
      setCards(filteredCards);
    }, 600);
  };
  return (
    <>
      <h1>Moyens de paiement</h1>
      <AddNewPaymentMethod profile={profile} addCard={addCard} />
      <h2 id="payment-methods-known" ref={paymentMethodKnownRef}>
        Vos moyens de paiement
      </h2>
      <ul className="payment-card-list">
        <li className="payment-card-item">
          <PaymentCard
            card={defaultCard}
            checked={true}
            setDefaultCard={activateCard}
          />
        </li>
        {cards
          .filter(card => card.id !== defaultCard.id)
          .map(card => (
            <li
              className={classnames('payment-card-item', {
                'payment-card-item--removed': card.action === 'removed'
              })}
              key={`payment-method-${card.id}`}
            >
              <PaymentCard
                card={card}
                checked={false}
                setDefaultCard={activateCard}
              />
              <div className="card-remove">
                <RemovePaymentMethod card={card} remove={removeCard} />
              </div>
            </li>
          ))}
      </ul>
      <style jsx>{paymentMethodsStyles}</style>
    </>
  );
};

PaymentMethods.propTypes = {
  profile: PropTypes.object.isRequired,
  cards: PropTypes.array.isRequired
};

export default PaymentMethods;
